<script>
  import { Circle } from "svelte-loading-spinners";
  import MediaQuery from "svelte-media-query";
  import ActiveFilters from "./Filters/ActiveFilters.svelte";
  import Error from "../../Common/Error.svelte";
  import FilterSection from "./Filters/FilterSection.svelte";
  import FilterSection__IE from "./Filters/FilterSection__IE.svelte";
  import Pagination from "./Pagination/Pagination.svelte";
  import PaginationLabel from "./Pagination/PaginationLabel.svelte";
  import SearchResult from "./SearchResult.svelte";
  import SortBy from "./SortBy.svelte";
  import MobileFiltersButton from "./FilterModal/MobileFiltersButton.svelte";
  import ModalWrapper, { bind } from "./FilterModal/ModalWrapper.svelte";
  import FilterModal from "./FilterModal/FilterModal.svelte";
  import { appState, browser, modal } from "../../../stores";

  // Constants
  const filterSections = [
    { key: "sectors", heading: "Sector" },
    { key: "reportTypes", heading: "Report Type" },
    { key: "publishedYears", heading: "Published Year" },
    { key: "fiscalYears", heading: "Fiscal Year" },
    { key: "organizations", heading: "Organizations" },
  ];
  const desktop = "(min-width: 981px)";
  const mobile = "(max-width: 980px)";

  // State
  $: ({ error, loading, numberOfResults, reports } = $appState);
  $: showPagination = !!numberOfResults;

  /**
   * Toggles between showing the Filter Modal or not
   */
  const showFilterModal = () => {
    modal.set(bind(FilterModal, { filterSections }));
  };

  $: {
    if (loading) modal.set(null);
  }

  $: {
    if (error) console.error(error);
  }
</script>

<ModalWrapper show={$modal}>
  <MediaQuery query={mobile} let:matches>
    {#if matches && numberOfResults}
      <div id="mobile-results-and-filter">
        <div>
          <p>{numberOfResults} Results</p>
          <p>
            Showing <PaginationLabel minimal={true} />
          </p>
        </div>
        <MobileFiltersButton openFiltersModal={() => showFilterModal()} />
      </div>
    {/if}
  </MediaQuery>

  <div class="container">
    <div id="reports-search-results">
      <MediaQuery query={desktop} let:matches>
        {#if matches}
          <div id="sort-by">
            <SortBy />
          </div>
          <div id="filter-sections-wrapper">
            {#each filterSections as filterSection}
              {#if browser.name === "ie"}
                <FilterSection__IE
                  key={filterSection.key}
                  heading={filterSection.heading}
                />
              {:else}
                <FilterSection
                  key={filterSection.key}
                  heading={filterSection.heading}
                />
              {/if}
            {/each}
          </div>
        {/if}
        <div id="search-results-arr">
          {#if loading}
            <div class="loading-wrap">
              <Circle size="100" color="#4a4a4a" unit="px" />
            </div>
          {:else if error}
            <ActiveFilters />
            <div class="empty-message">
              <Error>Oops!</Error>
              <p>
                We have had an unexpected issue at this time and are working to
                resolve the issue. Please try again at a later time.
              </p>
            </div>
          {:else}
            <ActiveFilters />
            {#if showPagination && matches}
              <PaginationLabel />
            {/if}

            {#if Array.isArray(reports)}
              {#if reports.length}
                {#each reports as report}
                  <SearchResult result={report} />
                {/each}
              {:else}
                <p class="empty-message">
                  No matching reports could be found. Try expanding your
                  filters, or another search term.
                </p>
              {/if}
            {/if}

            {#if showPagination}
              <Pagination />
            {/if}
          {/if}
        </div>
      </MediaQuery>
    </div>
  </div>
</ModalWrapper>

<style lang="scss">
  #reports-search-results {
    padding: 60px 0;
    display: flex;
  }

  #filter-sections-wrapper {
    display: flex;
    flex-direction: column;
    width: 30.97%; //420/1356
  }

  #search-results-arr {
    position: relative;
    padding-left: 50px;
    width: 69.03%; // 100% - 30.97%
  }
  #mobile-results-and-filter {
    background: rgba(235, 233, 233, 0.5);
    padding: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #mobile-results-and-filter > div > p {
    font-family: "Segoe UI", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #636768;
    padding: 0px;
  }

  #mobile-results-and-filter > div > p:first-child {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #2d2d2d;
    padding-bottom: 5px;
  }

  .empty-message {
    padding: 80px 40px;
    width: 100%;
    background: #f9f9f9;
    box-shadow: 0px 0px 6px rgb(0 0 0 / 10%);
    border-radius: 10px;
    margin-top: 80px;
    text-align: center;
  }

  .loading-wrap {
    padding: 120px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media screen and (max-width: 980px) {
    #reports-search-results {
      padding: 30px 0;
    }
    #search-results-arr {
      width: 100%;
      padding-left: 0;
      padding-top: 0;
    }
  }
</style>
